import React from 'react';
import { Heart } from 'lucide-react';
import { useFadeIn } from '../hooks/useFadeIn';
import { ImagePlaceholder } from './ImagePlaceholder';
export function BeforeAfter() {
  const {
    ref,
    isVisible
  } = useFadeIn();
  return <section id="resultados" className="py-24 bg-secondary border-y border-border" data-id="element-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13">
        <div className="text-center mb-16" data-id="element-14">
          <h2 className="font-serif text-3xl md:text-4xl text-white mb-4" data-id="element-15">
            Resultados Reales de Nuestros Pacientes
          </h2>
          <p className="text-gold text-lg max-w-2xl mx-auto" data-id="element-16">
            Transformaciones reales documentadas en Pereira
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-6 mb-16 transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`} data-id="element-17">
          {/* Card 1: Full image (3.jpg) — already has ANTES/DESPUÉS labels */}
          <div className="bg-card rounded-xl overflow-hidden border border-border group relative" data-id="element-18">
            <div className="relative aspect-[4/5] w-full bg-primary overflow-hidden flex items-center justify-center" data-id="element-19">
              <img src="https://cdn.magicpatterns.com/uploads/94MpKvjGa5kmwZs8nYfYGk/3.jpg" alt="Antes y Después - Diseño de Sonrisa en Resina" className="w-full h-full object-contain" data-id="element-20" />
            </div>
            <div className="p-6 relative" data-id="element-21">
              <div className="absolute -top-5 right-6 bg-primary border border-border rounded-full px-4 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-22">
                <span className="text-sm font-bold text-white" data-id="element-23">38</span>
                <Heart size={14} className="text-red-500 fill-red-500" data-id="element-24" />
              </div>
              <h3 className="text-white font-serif text-xl mb-1 mt-2" data-id="element-25">
                Diseño de Sonrisa en Resina
              </h3>
              <p className="text-gold text-sm" data-id="element-26">Pereira Capital del Eje</p>
            </div>
          </div>

          {/* Card 2: Full image (10.jpg) — top/bottom before/after */}
          <div className="bg-card rounded-xl overflow-hidden border border-border group relative" data-id="element-27">
            <div className="relative aspect-[4/5] w-full bg-primary overflow-hidden flex items-center justify-center" data-id="element-28">
              <img src="https://cdn.magicpatterns.com/uploads/wTPpRvpC83BrSv1U5TVGjT/10.jpg" alt="Antes y Después - Diseño de Sonrisa en Cerámica" className="w-full h-full object-contain" data-id="element-29" />
            </div>
            <div className="p-6 relative" data-id="element-30">
              <h3 className="text-white font-serif text-xl mb-1 mt-2" data-id="element-31">
                Diseño de Sonrisa en Cerámica
              </h3>
              <p className="text-gold text-sm" data-id="element-32">El mejor material del mercado</p>
            </div>
          </div>

          {/* Card 3: Diseño Completo en Cerámica */}
          <div className="bg-card rounded-xl overflow-hidden border border-border group relative" data-id="element-33">
            <div className="relative aspect-[4/5] w-full bg-primary overflow-hidden flex items-center justify-center" data-id="element-34">
              <img src="https://cdn.magicpatterns.com/uploads/6ZLTYNz8CmR4qXpiocbYpG/qqqqqq.jpg" alt="Perfeccionamiento Dental en Resina" className="w-full h-full object-contain" data-id="element-35" />
              <div className="absolute bottom-4 left-4 bg-primary/80 text-white text-xs font-bold px-3 py-1 rounded backdrop-blur-sm" data-id="element-36">
                ANTES / BEFORE
              </div>
              <div className="absolute bottom-4 right-4 bg-gold text-primary text-xs font-bold px-3 py-1 rounded shadow-lg" data-id="element-37">
                DESPUÉS / AFTER
              </div>
            </div>
            <div className="p-6 relative" data-id="element-38">
              <div className="absolute -top-5 right-6 bg-primary border border-border rounded-full px-4 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-39">
                <span className="text-sm font-bold text-white" data-id="element-40">460</span>
                <Heart size={14} className="text-red-500 fill-red-500" data-id="element-41" />
              </div>
              <h3 className="text-white font-serif text-xl mb-1 mt-2" data-id="element-42">
                Perfeccionamiento Dental en Resina
              </h3>
              <p className="text-gold text-sm" data-id="element-43">
                Alta Estética · Alta Durabilidad
              </p>
            </div>
          </div>

          {/* Card 4: Mini Diseño de Sonrisa (7.jpg) */}
          <div className="bg-card rounded-xl overflow-hidden border border-border group relative" data-id="element-44">
            <div className="relative aspect-[4/5] w-full bg-primary overflow-hidden flex items-center justify-center" data-id="element-45">
              <img src="https://cdn.magicpatterns.com/uploads/cRd9TBhmWc9U5XkVqoGQqi/7.jpg" alt="Mini Diseño de Sonrisa" className="w-full h-full object-contain" data-id="element-46" />
            </div>
            <div className="p-6 relative" data-id="element-47">
              <div className="absolute -top-5 right-6 bg-primary border border-border rounded-full px-4 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-48">
                <span className="text-sm font-bold text-white" data-id="element-49">312</span>
                <Heart size={14} className="text-red-500 fill-red-500" data-id="element-50" />
              </div>
              <h3 className="text-white font-serif text-xl mb-1 mt-2" data-id="element-51">
                Mini Diseño de Sonrisa
              </h3>
              <p className="text-gold text-sm" data-id="element-52">
                Transformación rápida y natural
              </p>
            </div>
          </div>

          {/* Card 5: Diseño de Sonrisa en Resina (6.jpg) */}
          <div className="bg-card rounded-xl overflow-hidden border border-border group relative" data-id="element-53">
            <div className="relative aspect-[4/5] w-full bg-primary overflow-hidden flex items-center justify-center" data-id="element-54">
              <img src="https://cdn.magicpatterns.com/uploads/gq11x9P5ncWcz9yyePTp5x/6.jpg" alt="Diseño de Sonrisa en Resina" className="w-full h-full object-contain" data-id="element-55" />
            </div>
            <div className="p-6 relative" data-id="element-56">
              <div className="absolute -top-5 right-6 bg-primary border border-border rounded-full px-4 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-57">
                <span className="text-sm font-bold text-white" data-id="element-58">485</span>
                <Heart size={14} className="text-red-500 fill-red-500" data-id="element-59" />
              </div>
              <h3 className="text-white font-serif text-xl mb-1 mt-2" data-id="element-60">
                Diseño de Sonrisa en Resina
              </h3>
              <p className="text-gold text-sm" data-id="element-61">Resultado natural y duradero</p>
            </div>
          </div>

          {/* Card 6: Blanqueamiento Dental (10.jpg) */}
          <div className="bg-card rounded-xl overflow-hidden border border-border group relative" data-id="element-62">
            <div className="relative aspect-[4/5] w-full bg-primary overflow-hidden flex items-center justify-center" data-id="element-63">
              <img src="https://cdn.magicpatterns.com/uploads/5Zp7h4BjEA5RJCZQbmRfHd/blanqueamiento_dental.jpg" alt="Blanqueamiento Dental" className="w-full h-full object-contain" data-id="element-64" />
            </div>
            <div className="p-6 relative" data-id="element-65">
              <div className="absolute -top-5 right-6 bg-primary border border-border rounded-full px-4 py-1.5 flex items-center gap-1.5 shadow-lg" data-id="element-66">
                <span className="text-sm font-bold text-white" data-id="element-67">198</span>
                <Heart size={14} className="text-red-500 fill-red-500" data-id="element-68" />
              </div>
              <h3 className="text-white font-serif text-xl mb-1 mt-2" data-id="element-69">
                Blanqueamiento Dental
              </h3>
              <p className="text-gold text-sm" data-id="element-70">
                Sonrisa radiante en una sola cita
              </p>
            </div>
          </div>
        </div>

        {/* CTA Banner — dark elegant with gold shimmer */}
        <div className="relative rounded-2xl p-8 md:p-12 flex flex-col md:flex-row items-center justify-between gap-6 shadow-2xl overflow-hidden border border-gold/40" style={{
        background: 'linear-gradient(135deg, #1a1a1a 0%, #111111 50%, #1a1a0a 100%)'
      }} data-id="element-71">
          {/* Top gold shimmer line */}
          <div className="absolute top-0 left-0 right-0 h-[2px]" style={{
          background: 'linear-gradient(90deg, transparent, #C9A84C, transparent)'
        }} data-id="element-72" />
          <div className="text-center md:text-left" data-id="element-73">
            <h3 className="font-serif text-white text-2xl md:text-3xl mb-3" data-id="element-74">
              ¿Quieres ver tu transformación?
            </h3>
            <p className="text-gray text-base md:text-lg" data-id="element-75">
              Únete a los cientos de pacientes satisfechos en Pereira
            </p>
          </div>
          <a href="https://www.instagram.com/odontologia_estetica_pereira" target="_blank" rel="noopener noreferrer" className="bg-primary border-2 border-gold text-gold hover:bg-gold hover:text-primary font-bold px-8 py-4 rounded-lg transition-all whitespace-nowrap flex-shrink-0 hover:shadow-[0_4px_20px_rgba(201,168,76,0.35)]" data-id="element-76">
            Ver Más en @odontologia_estetica_pereira
          </a>
        </div>
      </div>
    </section>;
}